/** Format cents to a USD currency string: 19500 → "$195.00" */
export function formatPrice(cents) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

/** Format a Date or ISO string to "Jun 23, 2026" */
export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

/** Format a date range: "Jun 23 – Jun 30, 2026" */
export function formatDateRange(checkIn, checkOut) {
  const inDate = new Date(checkIn);
  const outDate = new Date(checkOut);
  const opts = { month: 'short', day: 'numeric' };
  const inStr = inDate.toLocaleDateString('en-US', opts);
  const outStr = outDate.toLocaleDateString('en-US', { ...opts, year: 'numeric' });
  return `${inStr} – ${outStr}`;
}

/** Return human-readable label for a cancellation policy key */
export function formatPolicy(policy) {
  const labels = {
    full_refund: 'Full refund',
    partial_refund: '50% refund',
    no_refund: 'No refund',
  };
  return labels[policy] || policy;
}

/** Return a CSS color class based on decay progress (0 = full price → 1 = floor) */
export function decayColor(decayPercent) {
  if (decayPercent < 0.33) return 'decay-low';
  if (decayPercent < 0.66) return 'decay-mid';
  return 'decay-high';
}

/** Return a CSS class for the discount badge — greener and bolder as the discount grows */
export function discountColor(discountPct) {
  if (discountPct <= 20) return 'discount-light';
  if (discountPct <= 40) return 'discount-medium';
  if (discountPct <= 60) return 'discount-bright';
  return 'discount-deep';
}
